var InputBase = require('../base');

var Text = InputBase.extend( {
    bindData: function( sourceID ) {
        return this;
    }
} );

module.exports = Text;


/*****************
 ** WEBPACK FOOTER
 ** ./src/input-factory/text/index.js
 ** module id = 19
 ** module chunks = 0
 **/